function createDropdownEvent(
  elementId,
  pageId,
  eventId,
  eventType,
  autoStopEventId,
  mediaQueries,
  actionListId
) {
  return {
    id: eventId,
    name: eventType.includes("open") ? "Dropdown Open" : "Dropdown Close",
    animationType: mediaQueries.includes("main") ? "custom" : "preset",
    eventTypeId: eventType.includes("open")
      ? "DROPDOWN_OPEN"
      : "DROPDOWN_CLOSE",
    action: {
      id: "",
      actionTypeId: "GENERAL_START_ACTION",
      config: {
        delay: 0,
        easing: "",
        duration: 0,
        actionListId,
        affectedElements: {},
        playInReverse: false,
        autoStopEventId,
      },
    },
    mediaQueries,
    target: {
      id: `${pageId}|${elementId}`,
      appliesTo: "ELEMENT",
      styleBlockIds: [],
    },
    targets: [],
    config: {
      loop: false,
      playInReverse: false,
      scrollOffsetValue: null,
      scrollOffsetUnit: null,
      delay: null,
      direction: null,
      effectIn: null,
    },
    createdOn: Date.now(),
  };
}

function generateDropdownEvents(pageId, dropdownIds) {
  const events = {};

  dropdownIds.forEach((id, index) => {
    const openEventMainId = `nav-e-${index * 4 + 49}`; // Main media query OPEN
    const closeEventMainId = `nav-e-${index * 4 + 50}`; // Main media query CLOSE
    const openEventSmallId = `nav-e-${index * 4 + 51}`; // Small media queries OPEN
    const closeEventSmallId = `nav-e-${index * 4 + 52}`; // Small media queries CLOSE

    events[openEventMainId] = createDropdownEvent(
      id,
      pageId,
      openEventMainId,
      "open",
      closeEventMainId,
      ["main"],
      "nav-a-3"
    );
    events[closeEventMainId] = createDropdownEvent(
      id,
      pageId,
      closeEventMainId,
      "close",
      openEventMainId,
      ["main"],
      "nav-a-4"
    );

    events[openEventSmallId] = createDropdownEvent(
      id,
      pageId,
      openEventSmallId,
      "open",
      closeEventSmallId,
      ["medium", "small", "tiny"],
      "nav-a-5"
    );
    events[closeEventSmallId] = createDropdownEvent(
      id,
      pageId,
      closeEventSmallId,
      "close",
      openEventSmallId,
      ["medium", "small", "tiny"],
      "nav-a-6"
    );
  });

  return events;
}

function getEvents(pageId, navbarId, dropdownIds) {
  const events = generateDropdownEvents(pageId, dropdownIds);

  const eventsList = {
    events: {
      ...events,
    },
    actionLists: {
      "nav-a-3": {
        id: "nav-a-3",
        title: "Navbar 1 dropdown [Open] [Desktop]",
        actionItemGroups: [
          {
            actionItems: [
              {
                id: "nav-a-3-n",
                actionTypeId: "TRANSFORM_MOVE",
                config: {
                  delay: 0,
                  easing: "",
                  duration: 500,
                  target: {
                    useEventTarget: "CHILDREN",
                    selector: ".navbar1_dropdown-list",
                    selectorGuids: ["f13dff67-c1fb-5fe4-1996-d6999db1fbdb"],
                  },
                  yValue: 3,
                  xUnit: "PX",
                  yUnit: "rem",
                  zUnit: "PX",
                },
              },
              {
                id: "nav-a-3-n-2",
                actionTypeId: "STYLE_OPACITY",
                config: {
                  delay: 0,
                  easing: "",
                  duration: 500,
                  target: {
                    useEventTarget: "CHILDREN",
                    selector: ".navbar1_dropdown-list",
                    selectorGuids: ["f13dff67-c1fb-5fe4-1996-d6999db1fbdb"],
                  },
                  value: 0,
                  unit: "",
                },
              },
            ],
          },
          {
            actionItems: [
              {
                id: "nav-a-3-n-3",
                actionTypeId: "TRANSFORM_MOVE",
                config: {
                  delay: 0,
                  easing: "ease",
                  duration: 300,
                  target: {
                    useEventTarget: "CHILDREN",
                    selector: ".navbar1_dropdown-list",
                    selectorGuids: ["f13dff67-c1fb-5fe4-1996-d6999db1fbdb"],
                  },
                  yValue: 0,
                  xUnit: "PX",
                  yUnit: "rem",
                  zUnit: "PX",
                },
              },
              {
                id: "nav-a-3-n-4",
                actionTypeId: "STYLE_OPACITY",
                config: {
                  delay: 0,
                  easing: "ease",
                  duration: 200,
                  target: {
                    useEventTarget: "CHILDREN",
                    selector: ".navbar1_dropdown-list",
                    selectorGuids: ["f13dff67-c1fb-5fe4-1996-d6999db1fbdb"],
                  },
                  value: 1,
                  unit: "",
                },
              },
              {
                id: "nav-a-3-n-5",
                actionTypeId: "TRANSFORM_ROTATE",
                config: {
                  delay: 0,
                  easing: "ease",
                  duration: 300,
                  target: {
                    useEventTarget: "CHILDREN",
                    selector: ".dropdown-chevron",
                    selectorGuids: ["f13dff67-c1fb-5fe4-1996-d6999db1fbd6"],
                  },
                  zValue: 180,
                  xUnit: "DEG",
                  yUnit: "DEG",
                  zUnit: "deg",
                },
              },
            ],
          },
        ],
        useFirstGroupAsInitialState: true,
        createdOn: 1626241970095,
      },
      "nav-a-4": {
        id: "nav-a-4",
        title: "Navbar 1 dropdown [Close] [Desktop]",
        actionItemGroups: [
          {
            actionItems: [
              {
                id: "nav-a-4-n",
                actionTypeId: "STYLE_OPACITY",
                config: {
                  delay: 0,
                  easing: "ease",
                  duration: 200,
                  target: {
                    useEventTarget: "CHILDREN",
                    selector: ".navbar1_dropdown-list",
                    selectorGuids: ["f13dff67-c1fb-5fe4-1996-d6999db1fbdb"],
                  },
                  value: 0,
                  unit: "",
                },
              },
              {
                id: "nav-a-4-n-2",
                actionTypeId: "TRANSFORM_ROTATE",
                config: {
                  delay: 0,
                  easing: "ease",
                  duration: 300,
                  target: {
                    useEventTarget: "CHILDREN",
                    selector: ".dropdown-chevron",
                    selectorGuids: ["f13dff67-c1fb-5fe4-1996-d6999db1fbd6"],
                  },
                  zValue: 0,
                  xUnit: "DEG",
                  yUnit: "DEG",
                  zUnit: "deg",
                },
              },
            ],
          },
          {
            actionItems: [
              {
                id: "nav-a-4-n-3",
                actionTypeId: "TRANSFORM_MOVE",
                config: {
                  delay: 0,
                  easing: "ease",
                  duration: 0,
                  target: {
                    useEventTarget: "CHILDREN",
                    selector: ".navbar1_dropdown-list",
                    selectorGuids: ["f13dff67-c1fb-5fe4-1996-d6999db1fbdb"],
                  },
                  yValue: 4,
                  xUnit: "PX",
                  yUnit: "rem",
                  zUnit: "PX",
                },
              },
            ],
          },
        ],
        useFirstGroupAsInitialState: false,
        createdOn: 1626241970095,
      },
      "nav-a-5": {
        id: "nav-a-5",
        title: "Navbar 1 dropdown [Open] [Tablet]",
        actionItemGroups: [
          {
            actionItems: [
              {
                id: "nav-a-5-n",
                actionTypeId: "STYLE_SIZE",
                config: {
                  delay: 0,
                  easing: "",
                  duration: 500,
                  target: {
                    useEventTarget: "CHILDREN",
                    selector: ".navbar1_dropdown-list",
                    selectorGuids: ["f13dff67-c1fb-5fe4-1996-d6999db1fbdb"],
                  },
                  heightValue: 0,
                  widthUnit: "px",
                  heightUnit: "px",
                  locked: false,
                },
              },
            ],
          },
          {
            actionItems: [
              {
                id: "nav-a-5-n-2",
                actionTypeId: "STYLE_SIZE",
                config: {
                  delay: 0,
                  easing: "ease",
                  duration: 300,
                  target: {
                    useEventTarget: "CHILDREN",
                    selector: ".navbar1_dropdown-list",
                    selectorGuids: ["f13dff67-c1fb-5fe4-1996-d6999db1fbdb"],
                  },
                  widthUnit: "PX",
                  heightUnit: "AUTO",
                  locked: false,
                },
              },
              {
                id: "nav-a-5-n-3",
                actionTypeId: "TRANSFORM_ROTATE",
                config: {
                  delay: 0,
                  easing: "ease",
                  duration: 300,
                  target: {
                    useEventTarget: "CHILDREN",
                    selector: ".dropdown-chevron",
                    selectorGuids: ["f13dff67-c1fb-5fe4-1996-d6999db1fbd6"],
                  },
                  zValue: 180,
                  xUnit: "DEG",
                  yUnit: "DEG",
                  zUnit: "deg",
                },
              },
            ],
          },
        ],
        useFirstGroupAsInitialState: true,
        createdOn: 1626241970095,
      },
      "nav-a-6": {
        id: "nav-a-6",
        title: "Navbar 1 dropdown [Close] [Tablet]",
        actionItemGroups: [
          {
            actionItems: [
              {
                id: "nav-a-6-n",
                actionTypeId: "STYLE_SIZE",
                config: {
                  delay: 0,
                  easing: "ease",
                  duration: 200,
                  target: {
                    useEventTarget: "CHILDREN",
                    selector: ".navbar1_dropdown-list",
                    selectorGuids: ["f13dff67-c1fb-5fe4-1996-d6999db1fbdb"],
                  },
                  heightValue: 0,
                  widthUnit: "PX",
                  heightUnit: "px",
                  locked: false,
                },
              },
              {
                id: "nav-a-6-n-2",
                actionTypeId: "TRANSFORM_ROTATE",
                config: {
                  delay: 0,
                  easing: "ease",
                  duration: 300,
                  target: {
                    useEventTarget: "CHILDREN",
                    selector: ".dropdown-chevron",
                    selectorGuids: ["f13dff67-c1fb-5fe4-1996-d6999db1fbd6"],
                  },
                  zValue: 0,
                  xUnit: "DEG",
                  yUnit: "DEG",
                  zUnit: "deg",
                },
              },
            ],
          },
        ],
      },
    },
  };

  return eventsList;
}

// eslint-disable-next-line import/no-default-export
export default getEvents;
